import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'announcement', en);

const AnnouncementListConfig = {
  settings: {
    layout: { config: {} },
    nav: { title: 'Announcements' },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ANNOUNCEMENT,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/announcement/list',
      component: React.lazy(() => import('./AnnouncementList')),
    },
  ],
};

export default AnnouncementListConfig;
